import React, { useState, useEffect } from 'react';
import styled from 'styled-components';
import TextEditor from '../../new_components/organisms/TextEditor';
import { 
  Button, 
  SecondaryButton, 
  FormGroup, 
  Label, 
  Input, 
  Textarea, 
  ButtonGroup, 
  ErrorMessage 
} from './styles';

const CreateTemplate = ({ onSave, template, isEditing, onCancel }) => {
  const [templateName, setTemplateName] = useState('');
  const [templateDescription, setTemplateDescription] = useState('');
  const [subject, setSubject] = useState('');
  const [bodyContent, setBodyContent] = useState('');
  const [errors, setErrors] = useState({});

  // Initialize form with template data if editing
  useEffect(() => {
    if (template && isEditing) {
      setTemplateName(template.name);
      setTemplateDescription(template.description || '');
      setSubject(template.subject);
      setBodyContent(template.body);
    }
  }, [template, isEditing]);

  // Reset form when not editing
  useEffect(() => {
    if (!isEditing) {
      resetForm();
    }
  }, [isEditing]);

  const resetForm = () => {
    setTemplateName('');
    setTemplateDescription('');
    setSubject('');
    setBodyContent('');
    setErrors({});
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    
    // Validate form
    const newErrors = {};
    if (!templateName.trim()) newErrors.templateName = 'Template name is required';
    if (!subject.trim()) newErrors.subject = 'Subject is required';
    if (!bodyContent.trim() || bodyContent === '<p></p>') newErrors.bodyContent = 'Email body is required';
    
    if (Object.keys(newErrors).length > 0) {
      setErrors(newErrors);
      return;
    }
    
    // Clear previous errors
    setErrors({});
    
    // Prepare template data
    const templateData = {
      name: templateName,
      description: templateDescription,
      subject,
      body: bodyContent
    };
    
    // Call the onSave callback
    onSave(templateData);
    
    // Reset form if not editing
    if (!isEditing) {
      resetForm();
    }
  };

  return (
    <TemplateFormContainer>
      <TemplateForm>
        <h2>{isEditing ? 'Edit Template' : 'Create New Template'}</h2>
        
        <form onSubmit={handleSubmit}>
          <FormGroup>
            <Label htmlFor="templateName">Template Name</Label>
            <Input
              type="text"
              id="templateName"
              value={templateName}
              onChange={(e) => setTemplateName(e.target.value)}
              hasError={!!errors.templateName}
            />
            {errors.templateName && <ErrorMessage>{errors.templateName}</ErrorMessage>}
          </FormGroup>
          
          <FormGroup>
            <Label htmlFor="templateDescription">Description (Optional)</Label>
            <Textarea
              id="templateDescription"
              value={templateDescription}
              onChange={(e) => setTemplateDescription(e.target.value)}
              rows={2}
            />
          </FormGroup>
          
          <FormGroup>
            <Label htmlFor="subject">Email Subject</Label>
            <Input
              type="text"
              id="subject"
              value={subject}
              onChange={(e) => setSubject(e.target.value)}
              hasError={!!errors.subject}
            />
            {errors.subject && <ErrorMessage>{errors.subject}</ErrorMessage>}
          </FormGroup>
          
          <FormGroup>
            <Label>Email Body</Label>
            <TextEditor
              value={bodyContent}
              onChange={setBodyContent}
              hasError={!!errors.bodyContent}
            />
            {errors.bodyContent && <ErrorMessage>{errors.bodyContent}</ErrorMessage>}
          </FormGroup>
          
          <ButtonGroup>
            <Button type="submit">{isEditing ? 'Update Template' : 'Save Template'}</Button>
            {isEditing && (
              <SecondaryButton type="button" onClick={onCancel}>
                Cancel
              </SecondaryButton>
            )}
          </ButtonGroup>
        </form>
      </TemplateForm>
    </TemplateFormContainer>
  );
};

export default CreateTemplate;

// Component-specific styled components
const TemplateFormContainer = styled.div`
  max-width: 800px;
  margin: 0 auto;
`;

const TemplateForm = styled.div`
  background: #f9f9f9;
  border-radius: 8px;
  padding: 20px;
  box-shadow: 0 2px 4px rgba(0,0,0,0.1);
  
  h2 {
    margin-bottom: 20px;
    color: #333;
  }
  
  form {
    display: flex;
    flex-direction: column;
    gap: 16px;
  }
`; 